import { Menu } from "antd";

import { BaseMenuProps } from "./types";

const BaseMenu = ({ ...props }: BaseMenuProps) => {
  return <Menu {...props} />;
};

export default BaseMenu;
